<div class="w-full px-0 py-2 bg-white">
    <!-- A) No note + collapsed -->
    <button
      *ngIf="!orderMessage && !expanded"
      type="button"
      (click)="open()"
      class="flex items-center text-sm font-medium text-blue-600 underline md:no-underline md:hover:underline"
      [disabled]="isSaving"
      aria-expanded="false">
      <fa-icon icon="caret-right" class="mr-2"></fa-icon>{{ collapsedTitle }}
    </button>

    <!-- B) Note exists + collapsed (preview) -->
    <div *ngIf="orderMessage && !expanded" class="mt-2">
      <div class="flex items-center">
        <label class="block text-sm font-medium text-gray-700 ">Order Note</label>
        <button
          type="button"
          (click)="open()"
          class="ml-4 text-sm text-blue-600 underline md:no-underline md:hover:underline"
          [disabled]="isSaving">
          <fa-icon icon="caret-right" class="mr-2"></fa-icon>Edit your note
        </button>
      </div>

      <textarea
        readonly
        rows="6"
        class="w-full m-0 p-0 text-left text-gray-500 border-0 focus:ring-0 focus:outline-none resize-none
               bg-transparent shadow-none appearance-none whitespace-pre-wrap break-words leading-none"
        [value]="orderMessage || ''">
      </textarea>
    </div>

    <!-- C) Expanded (create/edit) -->
    <form #messageForm="ngForm" *ngIf="expanded" class="mt-3">
      <textarea
        id="order-message"
        name="orderMessage"
        rows="3"
        [attr.maxlength]="maxChars"
        placeholder="We will include this note when you pay."
        class="mt-1 block w-full border rounded-lg p-2 focus:outline-none focus:ring focus:border-blue-300 resize-none"
        [(ngModel)]="message"
        #messageModel="ngModel" [disabled]="isSaving"
        required>
      </textarea>

      <div class="flex justify-between items-center mt-1">
        <span
          *ngIf="messageModel.invalid && messageModel.touched && messageModel.errors?.['required']"
          class="text-xs text-red-500">
          Message is required.
        </span>
        <span *ngIf="!messageModel.invalid || !messageModel.touched || !messageModel.errors?.['required']"></span>
        <div
          class="text-xs text-right"
          [ngClass]="{ 'text-red-500': message.length > maxChars }">
          {{ message.length || 0 }} / {{ maxChars }}
        </div>
      </div>

      <div class="flex items-center mt-2">
        <button
          type="button"
          (click)="onSave()"
          [disabled]="!messageForm.form.dirty || isSaving"
          class="mt-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center">
          <span *ngIf="!isSaving">Save</span>
          <span *ngIf="isSaving" class="flex items-center">
            <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Saving...
          </span>
        </button>

        <button
          type="button"
          (click)="onClose()"
          [disabled]="isSaving"
          class="mt-1 ml-2 px-4 py-2 border rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
          Cancel
        </button>

        <!-- Remove only when there is already a saved note -->
        <button
          *ngIf="orderMessage"
          type="button"
          (click)="onRemove()"
          [disabled]="isSaving"
          class="mt-1 ml-2 px-4 py-2 border border-red-500 text-red-600 rounded-lg hover:bg-red-50 disabled:opacity-50 disabled:cursor-not-allowed">
          Remove
        </button>
      </div>
    </form>
  </div>
